import { basics, basicsDescription } from "../../basics";
import AboutShopInFooter from "./AboutShopInFooter";
import CallInformations from "./CallInformations";
import GetApplications from "./GetApplications";

const MainFooter = () => {
  return (
    <div className="bg-gray-700 pb-20">
      <div className="hidden sm:flex sm:flex-row justify-between  text-zinc-100 rounded pt-2 pb-12 px-1 max-w-[1400px] mx-auto">
        <div className="p-2  sm:w-2/4 ">
          <AboutShopInFooter />
        </div>
        <div className="p-2  sm:w-1/4 ">
          <CallInformations />
        </div>
        <div className="p-2  sm:w-1/4 text-zinc-50">
          <GetApplications />
        </div>
      </div>
      <div className="flex sm:hidden flex-col items-stretch text-zinc-100 rounded pt-4 pb-8 px-4 gap-8">
        <div className="w-full">
          <CallInformations />
        </div>
        <div className="w-full text-zinc-50">
          <GetApplications />
        </div>
      </div>
    </div>
  );
};

export default MainFooter;
